import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { CheckCircle2, Copy, ExternalLink, ArrowRight } from 'lucide-react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { getAgreementByCode } from '../lib/persistence';
import { Agreement } from '../types';
export function AgreementCreated() {
  const {
    code
  } = useParams<{
    code: string;
  }>();
  const [agreement, setAgreement] = useState<Agreement | null>(null);
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (code) {
      getAgreementByCode(code).then(setAgreement);
    }
  }, [code]);
  if (!agreement) {
    return <Layout data-id="element-90">
        <div className="flex items-center justify-center min-h-[60vh]" data-id="element-91">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" data-id="element-92" />
        </div>
      </Layout>;
  }
  const clientLink = `${window.location.origin}/agreement/${code}`;
  const handleCopy = () => {
    navigator.clipboard.writeText(clientLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <Layout data-id="element-93">
      <div className="max-w-xl mx-auto px-4 py-16" data-id="element-94">
        <div className="text-center mb-8" data-id="element-95">
          <div className="inline-flex w-16 h-16 bg-green-100 rounded-full items-center justify-center mb-6" data-id="element-96">
            <CheckCircle2 className="w-8 h-8 text-green-600" data-id="element-97" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-98">
            ¡Acuerdo creado con éxito!
          </h1>
          <p className="text-gray-500" data-id="element-99">
            El código de tu acuerdo es{' '}
            <span className="font-mono font-bold text-gray-900" data-id="element-100">{code}</span>
          </p>
        </div>

        <Card className="mb-8" data-id="element-101">
          <div className="space-y-6" data-id="element-102">
            <div data-id="element-103">
              <p className="text-sm font-medium text-gray-900 mb-2" data-id="element-104">
                Enlace para tu cliente
              </p>
              <p className="text-xs text-gray-500 mb-3" data-id="element-105">
                Compartí este enlace con{' '}
                {agreement.client_name || agreement.client_email}. Podrá revisar
                los detalles y realizar el pago para asegurar los fondos.
              </p>
              <div className="flex items-center gap-2" data-id="element-106">
                <div className="flex-1 bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 font-mono text-sm text-gray-600 truncate" data-id="element-107">
                  {clientLink}
                </div>
                <Button variant="secondary" onClick={handleCopy} icon={copied ? <CheckCircle2 className="w-4 h-4 text-green-600" data-id="element-109" /> : <Copy className="w-4 h-4" data-id="element-110" />} data-id="element-108">
                  {copied ? 'Copiado' : 'Copiar'}
                </Button>
              </div>
            </div>

            <div className="border-t border-gray-100 pt-6" data-id="element-111">
              <p className="text-sm font-medium text-gray-900 mb-4" data-id="element-112">
                ¿Qué sigue?
              </p>
              <ul className="space-y-4" data-id="element-113">
                <li className="flex gap-3" data-id="element-114">
                  <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0 text-xs font-bold text-gray-600" data-id="element-115">
                    1
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-116">
                    Tu cliente abre el enlace y paga el monto acordado.
                  </p>
                </li>
                <li className="flex gap-3" data-id="element-117">
                  <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0 text-xs font-bold text-gray-600" data-id="element-118">
                    2
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-119">
                    Los fondos quedan protegidos en Agreexa.
                  </p>
                </li>
                <li className="flex gap-3" data-id="element-120">
                  <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0 text-xs font-bold text-gray-600" data-id="element-121">
                    3
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-122">
                    Prestás el servicio y registrás el resultado.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </Card>

        <div className="flex flex-col sm:flex-row gap-3" data-id="element-123">
          <Link to={`/agreement/${code}/detail`} className="flex-1" data-id="element-124">
            <Button fullWidth variant="outline" icon={<ExternalLink className="w-4 h-4" data-id="element-126" />} data-id="element-125">
              Ver detalles del acuerdo
            </Button>
          </Link>
          <Link to="/dashboard" className="flex-1" data-id="element-127">
            <Button fullWidth icon={<ArrowRight className="w-4 h-4" data-id="element-129" />} data-id="element-128">
              Ir a mis acuerdos
            </Button>
          </Link>
        </div>
      </div>
    </Layout>;
}